module.exports = __webpack_public_path__ + "static/media/AndroidFacebookFallback2.55dc2399.png";